module.exports = __webpack_public_path__ + "img/dam-sire-list.2c8c24a5.png";